import ReactOnRails from 'react-on-rails/client';
import SessionPage from '../../src/SessionPage/ror_components/SessionPage.client.jsx';

ReactOnRails.register({SessionPage});